const map = {
	"./Ecommerce/Products-Ecommerce-image-1.jpeg": 9327,
	"./Ecommerce/Products-Ecommerce-image-10.jpeg": 5945,
	"./Ecommerce/Products-Ecommerce-image-11.jpeg": 4370,
	"./Ecommerce/Products-Ecommerce-image-12.jpeg": 1519,
	"./Ecommerce/Products-Ecommerce-image-13.jpeg": 1032,
	"./Ecommerce/Products-Ecommerce-image-14.jpeg": 4525,
	"./Ecommerce/Products-Ecommerce-image-16.jpeg": 227,
	"./Ecommerce/Products-Ecommerce-image-17.jpeg": 4924,
	"./Ecommerce/Products-Ecommerce-image-2.jpeg": 2018,
	"./Ecommerce/Products-Ecommerce-image-3.jpeg": 2873,
	"./Ecommerce/Products-Ecommerce-image-4.jpeg": 8972,
	"./Ecommerce/Products-Ecommerce-image-5.jpeg": 1251,
	"./Ecommerce/Products-Ecommerce-image-6.jpeg": 6838,
	"./Ecommerce/Products-Ecommerce-image-7.jpeg": 1853,
	"./Ecommerce/Products-Ecommerce-image-8.jpeg": 8656,
	"./Ecommerce/Products-Ecommerce-image-9.jpeg": 9479,
	"./Ecommerce/Products-Electronics-image-15.jpeg": 1211,
	"./apparel/Products-Fashion-image-1.jpeg": 3080,
	"./apparel/Products-Fashion-image-10.jpeg": 7272,
	"./apparel/Products-Fashion-image-11.jpeg": 5791,
	"./apparel/Products-Fashion-image-12.jpeg": 1522,
	"./apparel/Products-Fashion-image-13.jpeg": 5529,
	"./apparel/Products-Fashion-image-14.jpeg": 364,
	"./apparel/Products-Fashion-image-15.jpeg": 1971,
	"./apparel/Products-Fashion-image-16.jpeg": 3686,
	"./apparel/Products-Fashion-image-2.jpeg": 1225,
	"./apparel/Products-Fashion-image-3.jpeg": 370,
	"./apparel/Products-Fashion-image-4.jpeg": 9603,
	"./apparel/Products-Fashion-image-5.jpeg": 7324,
	"./apparel/Products-Fashion-image-6.jpeg": 205,
	"./apparel/Products-Fashion-image-7.jpeg": 5190,
	"./apparel/Products-Fashion-image-8.jpeg": 7831,
	"./chocolate/Products-Chocolate-image-1.jpeg": 9091,
	"./chocolate/Products-Chocolate-image-10.jpeg": 2965,
	"./chocolate/Products-Chocolate-image-11.jpeg": 8334,
	"./chocolate/Products-Chocolate-image-12.jpeg": 2379,
	"./chocolate/Products-Chocolate-image-15.jpeg": 7386,
	"./chocolate/Products-Chocolate-image-2.jpeg": 6614,
	"./chocolate/Products-Chocolate-image-3.jpeg": 4877,
	"./chocolate/Products-Chocolate-image-4.jpeg": 2264,
	"./chocolate/Products-Chocolate-image-5.jpeg": 6207,
	"./chocolate/Products-Chocolate-image-6.jpeg": 5618,
	"./chocolate/Products-Chocolate-image-7.jpeg": 1001,
	"./chocolate/Products-Chocolate-image-8.jpeg": 8676,
	"./chocolate/Products-Chocolate-image-9.jpeg": 7195,
	"./chocolate/Products-Sweets-image-1.jpeg": 3134,
	"./chocolate/it.jpeg": 4255,
	"./cosmetics/Products-Cosmetics-image-1.jpeg": 9019,
	"./cosmetics/Products-Cosmetics-image-10.jpeg": 7421,
	"./cosmetics/Products-Cosmetics-image-11.jpeg": 7206,
	"./cosmetics/Products-Cosmetics-image-12.jpeg": 3123,
	"./cosmetics/Products-Cosmetics-image-13.jpeg": 1468,
	"./cosmetics/Products-Cosmetics-image-14.jpeg": 2489,
	"./cosmetics/Products-Cosmetics-image-15.jpeg": 7266,
	"./cosmetics/Products-Cosmetics-image-2.jpeg": 8638,
	"./cosmetics/Products-Cosmetics-image-3.jpeg": 21,
	"./cosmetics/Products-Cosmetics-image-4.jpeg": 2688,
	"./cosmetics/Products-Cosmetics-image-5.jpeg": 6743,
	"./cosmetics/Products-Cosmetics-image-6.jpeg": 9834,
	"./cosmetics/Products-Cosmetics-image-7.jpeg": 1457,
	"./cosmetics/Products-Cosmetics-image-8.jpeg": 3484,
	"./cosmetics/Products-Cosmetics-image-9.jpeg": 9411,
	"./electronics/Products-Electronics-image-1.jpeg": 933,
	"./electronics/Products-Electronics-image-10.jpeg": 9659,
	"./electronics/Products-Electronics-image-11.jpeg": 2628,
	"./electronics/Products-Electronics-image-12.jpeg": 7701,
	"./electronics/Products-Electronics-image-13.jpeg": 9390,
	"./electronics/Products-Electronics-image-14.jpeg": 7399,
	"./electronics/Products-Electronics-image-15 (1).jpeg": 442,
	"./electronics/Products-Electronics-image-16.jpeg": 7985,
	"./electronics/Products-Electronics-image-2.jpeg": 2372,
	"./electronics/Products-Electronics-image-3.jpeg": 891,
	"./electronics/Products-Electronics-image-4.jpeg": 4314,
	"./electronics/Products-Electronics-image-5.jpeg": 1009,
	"./electronics/Products-Electronics-image-6.jpeg": 128,
	"./electronics/Products-Electronics-image-8.jpeg": 310,
	"./electronics/Products-Electronics-image-9.jpeg": 8573,
	"./foods/Products-Sweets-image-1.jpeg.jpeg": 1311,
	"./foods/Products-Sweets-image-10.jpeg": 3623,
	"./foods/Products-Sweets-image-11.jpg": 3895,
	"./foods/Products-Sweets-image-12.jpg": 3912,
	"./foods/Products-Sweets-image-13.jpeg.jpeg": 3594,
	"./foods/Products-Sweets-image-14.jpeg.jpeg": 3673,
	"./foods/Products-Sweets-image-15.jpeg": 340,
	"./foods/Products-Sweets-image-2.jpeg": 7096,
	"./foods/Products-Sweets-image-3.jpeg": 5343,
	"./foods/Products-Sweets-image-4.jpeg": 9206,
	"./foods/Products-Sweets-image-5.jpeg": 7869,
	"./foods/Products-Sweets-image-6.jpg": 9027,
	"./foods/Products-Sweets-image-7.jpeg": 7267,
	"./foods/Products-Sweets-image-8.jpeg.jpeg": 7850,
	"./foods/Products-Sweets-image-9.jpeg.jpeg": 1783,
	"./gifts/Products-CorporateGifting-image-1.jpeg": 9409,
	"./gifts/Products-CorporateGifting-image-10.jpeg": 4399,
	"./gifts/Products-CorporateGifting-image-11.jpeg": 6984,
	"./gifts/Products-CorporateGifting-image-12.jpeg": 6649,
	"./gifts/Products-CorporateGifting-image-13.jpeg": 802,
	"./gifts/Products-CorporateGifting-image-14.jpeg": 6531,
	"./gifts/Products-CorporateGifting-image-15.jpeg": 604,
	"./gifts/Products-CorporateGifting-image-2.jpeg": 8096,
	"./gifts/Products-CorporateGifting-image-3.jpeg": 8919,
	"./gifts/Products-CorporateGifting-image-4.jpeg": 8798,
	"./gifts/Products-CorporateGifting-image-5.jpeg": 9557,
	"./gifts/Products-CorporateGifting-image-6.jpeg": 5636,
	"./gifts/Products-CorporateGifting-image-7.jpeg": 8379,
	"./gifts/Products-CorporateGifting-image-8.jpeg": 5106,
	"./gifts/Products-CorporateGifting-image-9.jpeg": 5961,
	"./gifts/premiumCards/Deboss.jpeg": 4264,
	"./gifts/premiumCards/Emboss.jpeg": 5493,
	"./gifts/premiumCards/Gold foil.jpeg": 1994,
	"./gifts/premiumCards/Pattern finish.jpeg": 479,
	"./gifts/premiumCards/Silver foil.jpeg": 1719,
	"./gifts/premiumCards/Spot UV.jpeg": 5745,
	"./gifts/premiumCards/Velvet finish.jpeg": 9951,
	"./jewelry/Products-Jewelry-image-1.jpeg": 9547,
	"./jewelry/Products-Jewelry-image-10.jpeg": 6221,
	"./jewelry/Products-Jewelry-image-11.jpeg": 4902,
	"./jewelry/Products-Jewelry-image-12.jpeg": 7235,
	"./jewelry/Products-Jewelry-image-13.jpeg": 6972,
	"./jewelry/Products-Jewelry-image-14.jpeg": 6745,
	"./jewelry/Products-Jewelry-image-15.jpeg": 882,
	"./jewelry/Products-Jewelry-image-16 (2).jpeg": 1338,
	"./jewelry/Products-Jewelry-image-2.jpeg": 6417,
	"./jewelry/Products-Jewelry-image-3.jpeg": 5413,
	"./jewelry/Products-Jewelry-image-4.jpeg": 9936,
	"./jewelry/Products-Jewelry-image-5.jpeg": 9511,
	"./jewelry/Products-Jewelry-image-6.jpeg": 8522,
	"./jewelry/Products-Jewelry-image-7.jpeg": 8561,
	"./jewelry/Products-Jewelry-image-8.jpeg": 2956,
	"./jewelry/Products-Jewelry-image-9.jpeg": 3219,
	"./perfume/Products-Perfume-image-1.jpeg": 3255,
	"./perfume/Products-Perfume-image-10.jpeg": 3838,
	"./perfume/Products-Perfume-image-11.jpeg": 4762,
	"./perfume/Products-Perfume-image-12.jpeg": 2455,
	"./perfume/Products-Perfume-image-13.jpeg": 576,
	"./perfume/Products-Perfume-image-14.jpeg": 1381,
	"./perfume/Products-Perfume-image-15.jpeg": 8046,
	"./perfume/Products-Perfume-image-2.jpeg": 1546,
	"./perfume/Products-Perfume-image-3.jpeg": 4497,
	"./perfume/Products-Perfume-image-4.jpeg": 6900,
	"./perfume/Products-Perfume-image-5.jpeg": 9643,
	"./perfume/Products-Perfume-image-6.jpeg": 5953,
	"./perfume/Products-Perfume-image-7.jpeg": 245,
	"./perfume/Products-Perfume-image-8.jpeg": 2904,
	"./perfume/Products-Perfume-image-9.jpeg": 799,
	"./toys/ChatGPTImageAug11202606_53_27P.jpeg": 4593,
	"./toys/ChatGPTImageAug11202607_02_39P.jpeg": 8983,
	"./toys/ChatGPTImageAug11202607_08_11P.jpeg": 7667,
	"./toys/ChatGPTImageAug11202607_11_31P.jpeg": 4491,
	"./toys/ChatGPTImageAug11202607_13_29P.jpeg": 8674,
	"./toys/ChatGPTImageAug11202608_50_02P.jpeg": 2029,
	"./toys/ChatGPTImageAug11202608_52_36P.jpeg": 9250,
	"./toys/ChatGPTImageAug12202601_51_54P.jpeg": 8609,
	"./toys/ChatGPTImageAug12202601_54_28P.jpeg": 9115,
	"./toys/ChatGPTImageAug12202602_11_11P.jpeg": 5983,
	"./toys/ChatGPTImageAug12202602_15_36P.jpeg": 9890,
	"./toys/ChatGPTImageAug12202602_17_19P.jpeg": 7029,
	"./toys/ChatGPTImageAug12202602_25_26P.jpeg": 8534,
	"./toys/ChatGPTImageAug12202602_28_46P.jpeg": 5015,
	"./toys/ChatGPTImageAug12202602_50_41P.jpeg": 5207
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8448;